import { FC } from 'react';

export const EmptyPresetsSvg: FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="54" viewBox="0 0 35 54" fill="none">
      <path
        d="M24.521 36.8862L0.941895 46.4067V10.7534L24.521 1.229V36.8862Z"
        stroke="#24275B"
        stroke-width="1.00333"
        stroke-miterlimit="10"
      />
      <path
        d="M4.75781 12.5339L4.75781 49.2687L30.0432 39.3419L30.0432 2.60351L4.75781 12.5339Z"
        fill="#24275B"
      />
      <mask
        id="mask0_6246_8577"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="9"
        y="6"
        width="26"
        height="48"
      >
        <path
          d="M33.8087 43.2422L9.52649 52.7754V17.1182L33.8087 7.58203V43.2422Z"
          fill="white"
          stroke="#C7C8E0"
          stroke-width="1.00333"
          stroke-miterlimit="10"
        />
      </mask>
      <g mask="url(#mask0_6246_8577)">
        <path
          d="M33.8087 30.1748V43.2412L9.52649 52.7744V37.1143L13.7228 33.2139L18.3683 34.5498L18.6534 34.6318L18.8624 34.4209L22.1593 31.1006L26.4357 32.4258L26.7101 32.5107L26.923 32.3164L30.5607 28.9863L33.8087 30.1748Z"
          fill="white"
          stroke="#C7C8E0"
          stroke-width="1.00333"
          stroke-miterlimit="10"
        />
      </g>
      <mask
        id="mask1_6246_8577"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="9"
        y="5"
        width="26"
        height="48"
      >
        <path
          d="M33.8087 41.8276L9.52649 51.3608V15.7036L33.8087 6.16748V41.8276Z"
          fill="white"
          stroke="#C7C8E0"
          stroke-width="1.00333"
          stroke-miterlimit="10"
        />
      </mask>
      <g mask="url(#mask1_6246_8577)">
        <path
          d="M33.8087 43.3198L9.52649 52.7778V15.7036L33.8087 6.16748V43.3198Z"
          fill="white"
          stroke="#C7C8E0"
          stroke-width="1.00333"
          stroke-miterlimit="10"
        />
      </g>
      <path
        d="M11.7557 49.3707V47.2374L18.7795 44.4214V46.5547L11.7557 49.3707Z"
        fill="#E7E9F4"
        stroke="#E7E9F4"
        stroke-width="1.00333"
      />
      <path
        d="M11.7557 22.7055V18.1763L31.7734 10.332L31.8571 14.7741L11.7557 22.7055Z"
        fill="#E7E9F4"
      />
      <path
        d="M11.7557 28.7665V24.2373L31.7734 16.3931L31.8571 20.8352L11.7557 28.7665Z"
        fill="#E7E9F4"
      />
    </svg>
  );
};
